import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalSection,
  ModalFooter,
  Form,
} from '@axiom/ui';
import type { Candidate, Opportunity } from '@axiom/validation';
import { CandidateWorkFeedHideSchema } from '@axiom/validation';

import { WorkFeedApi } from '../../api/work-feed-api';
import { CandidateOpportunitiesApi } from '../../api/candidate-opportunities-api';

export type WorkFeedHideOpportunityModalProps = {
  candidateId: Candidate['id'];
  onClose: () => void;
  opportunityId: Opportunity['id'];
  name?: string;
};

export const WorkFeedHideOpportunityModal = ({
  candidateId,
  onClose,
  opportunityId,
  name = 'WORK_FEED_HIDE_OPPORTUNITY_MODAL',
}: WorkFeedHideOpportunityModalProps) => (
  <Form
    name={name}
    schema={CandidateWorkFeedHideSchema}
    initialValues={{ opportunityId }}
    onSubmit={async () => {
      await CandidateOpportunitiesApi.createWorkFeedHidden({
        candidateId,
        body: { opportunityId },
      });
      await WorkFeedApi.refreshAllOfWorkFeed(candidateId);
      onClose();
    }}
  >
    {({ fireSubmit }) => (
      <Modal name="HIDE_OPPORTUNITY_MODAL" size="confirm">
        <ModalHeader onClose={onClose} name="HIDE_OPPORTUNITY_MODAL_HEADER">
          Hide opportunity
        </ModalHeader>
        <ModalSection name="HIDE_OPPORTUNITY_MODAL_SECTION">
          This will remove this opportunity from your feed permanently, and will
          enable us to provide you with better recommendations in the future.
        </ModalSection>
        <ModalFooter name="HIDE_OPPORTUNITY_MODAL_FOOTER">
          <Button
            variation="outline"
            name="HIDE_OPPORTUNITY_MODAL_CANCEL"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>

          <Button
            name="HIDE_OPPORTUNITY_MODAL_SUBMIT"
            onClick={() => {
              void fireSubmit();
            }}
          >
            Hide
          </Button>
        </ModalFooter>
      </Modal>
    )}
  </Form>
);
